import React, { Component } from "react"
import styled from "styled-components"

const TermsBox = styled.div`
  padding: 48px 0;
  max-width: 80rem;
  margin: 0 auto;

  @media (min-width: 768px) {
    padding: 64px 0;
  }
`

const Terms = styled.div`
  margin: 0 auto;
  max-width: 1280px;
  width: 90%;
`

const Header = styled.h1`
  font-size: 36px;
  font-family: "Poppins-SemiBold";
  color: #5225ee;
  @media (min-width: 768px) {
    font-size: 48px;
  }
`

const SubHeader = styled.p`
  margin: 0 0 16px;
  font-size: 16px;
  line-height: 1.5;
  color: #474c72;
`

const Divider = styled.hr`
  margin-top: 16px;
  margin-bottom: 16px;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
`

const TermsHeader = styled.p`
  font-weight: bolder;
  font-family: "Poppins-Medium";
  font-size: 18px;
  line-height: 1.5;
`

const TermHeader = styled.h3`
  margin-bottom: 16px;
  font-family: "Poppins-Medium", sans-serif;
  color: #5225ee;
  font-size: 18px;
`

const TermP = styled.p`
  margin: 0 0 16px;
  font-size: 1rem;
  line-height: 1.5;
  color: #474c72;
`

const TermList = styled.ul`
  padding-left: 18px;
`

const ListItem = styled.li`
  margin-bottom: 1.5rem;
`

const Strong = styled.strong`
  font-family: "Poppins-SemiBold";
`

export default class extends Component {
  render() {
    return (
      <TermsBox>
        <Terms>
          <Header>Terms of Service</Header>
          <SubHeader>
            Welcome to Codehall! Founded on the mission to teach a billion kids
            to code, Codehall is the world's first fully interactive coding
            school and educational tech platform that teaches kids to code.
            Beyond technical skills, our curriculum encourages creativity,
            instills confidence, and promotes critical thinking. Our physical
            and digital programs are designed specifically for kids to learn in
            a fun and collaborative way. The following Terms of Service (the
            “Terms”) apply, as the name suggests, when you view or use our
            Service (as defined below).
          </SubHeader>
          <Divider></Divider>
          <TermsHeader>
            <strong>
              BY ACCESSING OR USING OUR SERVICE, YOU ACKNOWLEDGE THAT YOU HAVE
              READ, UNDERSTAND, AND AGREE WITH OUR TERMS. THESE TERMS APPLY TO
              YOU AND THE KIDS SET FORTH IN YOUR ACCOUNT FOR ALL PAST, PRESENT,
              AND FUTURE USE OF THE SERVICE PROVIDED BY CODEHALL, INC. AND
              TUTORHALL INC. AS WELL AS THEIR AFFILIATES AND
              SUBSIDIARIES (“HALLMATE”). IF YOU DO NOT AGREE TO THESE TERMS,
              THEN YOU ARE UNFORTUNATELY NOT PERMITTED TO ACCESS OR USE THE
              SERVICE. YOU AGREE THAT NO ORAL REPRESENTATIONS OR STATEMENTS HAVE
              BEEN MADE APART FROM THESE TERMS OR ANY SIGNED AGREEMENTS.
            </strong>
          </TermsHeader>
          <TermHeader>The Company</TermHeader>
          <TermP>
            Codehall (the “Company”) refers to Codehall, Inc. and Tutorhall Inc. as well as their affiliates and
            subsidiaries (collectively "Codehall", “we”, “us”, “our”, or the
            “Company”).
          </TermP>
          <TermHeader>The Service</TermHeader>
          <TermP>
            Our Service teaches kids how to code and other STEM topics, while
            having fun and being creative using software, products, and programs
            designed by Codehall specifically for kids, including but not
            limited to the use of our website (
            <a href="http://www.codehall.ca">
              <u>www.codehall.ca</u>
            </a>
            ), programs offered on our website, Codehall software and
            applications, virtual experiences via Codehall platforms or
            third-party platforms, and/or in-person events (collectively and
            individually the “Service”).
          </TermP>
          <TermHeader>Your Account</TermHeader>
          <TermP>
            To register a Codehall account, you must be at least eighteen (18)
            years old and a parent/legal guardian of any minors whom you add to
            your account. You are responsible for any and all actions using your
            account; therefore, you agree to maintain confidentiality of your
            account, including but not limited to restricting access to your
            devices and password. You must notify us immediately upon becoming
            aware of any breach of security or unauthorized use of your account.
            You may not use as a username the name of another person or entity
            or that is not lawfully available for use, a name or trademark that
            is subject to any rights of another person or entity other than you,
            without appropriate authorization, or any name that is offensive,
            vulgar, or obscene. Company will not be responsible for any
            liabilities, losses, or damages arising out of the unauthorized use
            of your account or any public display or misuse of your user
            content. Company does not, and cannot, prescreen or monitor all user
            content.
          </TermP>
          <TermHeader>Representation</TermHeader>
          <TermP>
            You acknowledge that you have the authority to agree to these Terms
            as a parent or guardian on behalf of the kids set forth by you under
            your account (“your kids”).
          </TermP>
          <TermHeader>Prohibited Use</TermHeader>
          <TermP>
            To ensure safe and productive learning, your permission to use the
            Service is contingent on the following restrictions. You agree that
            you will not under any circumstances:
          </TermP>
          <TermList>
            <ListItem>
              <TermP>
                Submit false or misleading information; post abusive,
                defamatory, false, obscene, offensive, malicious, or threatening
                content;
              </TermP>
            </ListItem>
            <ListItem>
              <TermP>Use the Service for any unlawful purpose;</TermP>
            </ListItem>
            <ListItem>
              <TermP>
                Solicit others to perform or participate in any unlawful acts;
              </TermP>
            </ListItem>
            <ListItem>
              <TermP>Harass, abuse, or harm any person;</TermP>
            </ListItem>
            <ListItem>
              <TermP>Access another user’s account without permission;</TermP>
            </ListItem>
            <ListItem>
              <TermP>
                Infringe upon or violate the intellectual property rights of
                Codehall or others;
              </TermP>
            </ListItem>
            <ListItem>
              <TermP>
                Collect or track the personal information of others; or
              </TermP>
            </ListItem>
            <ListItem>
              <TermP>
                Interfere with the proper functioning of the Service.
              </TermP>
            </ListItem>
          </TermList>
          <TermHeader>Your Privacy</TermHeader>
          <TermP>
            Your privacy is very important to us. When you access or use the
            Service, you signify your agreement to our{" "}
            <a href="https://www.codehall.ca/privacy-policy/">
              <u>Privacy Policy</u>
            </a>
            . To provide you with a safe and high-quality experience, we may
            monitor or record activity during virtual sessions, in-person
            events, and communications for quality assurance, training,
            security, and product development purposes.
          </TermP>
          <TermHeader>Your Free Trial</TermHeader>
          <TermP>
            Your 7-day free trial begins on the date that you select and ends at
            11:59pm CST on the seventh day after. Upon completion of your trial
            period, you will automatically be enrolled as a Member for a monthly
            fee charged to the credit card provided. If you do not wish to
            become a Member, you may cancel at any time during your trial period
            by emailing{" "}
            <a href="mailto:support@codehall.ca">support@codehall.ca</a>.
            Reminders will be sent three (3) days and one (1) day before your
            free trial ends. Limit one (1) free trial per kid.
          </TermP>
          <TermHeader>Your Purchases</TermHeader>
          <TermP>
            If you wish to make any purchases available through the Service, you
            will be required to supply a valid payment method accepted by
            Codehall and accurate billing information, including full legal
            name, address, and telephone number. You represent and warrant that
            (i) you have the legal right to use any and all credit cards or
            other payment methods in connection with any of your purchases and
            (ii) the information you supply to us is true, accurate, and
            complete. By submitting your payment method, you authorize Codehall
            to charge payments for all your purchases and subscriptions under
            your Account. The Service may employ the use of third-party services
            for the purpose of facilitating payment and the completion of any
            purchase. By submitting your information, you grant us the right to
            provide your information to these third parties subject to our{" "}
            <a href="https://www.codehall.ca/privacy-policy/">
              <u>Privacy Policy</u>
            </a>
            . Your credit card information will always be encrypted during
            transfer over networks for the purpose of a transaction. We reserve
            the right to refuse or cancel your purchases at any time due to
            availability, error in offering description or price, suspicion of
            unauthorized or illegal activity, or other reasons at our sole
            discretion. You will be charged and agree to pay the full price for
            all purchases made under your account at the time that they occur,
            with the exception of programs that have a specified payment
            schedule or billing cycle. All prices are subject to change upon
            reasonable notice by Codehall. Any change to subscription pricing
            will take effect after the end of the current Billing Cycle during
            which the price change occurred. After receiving notice with
            sufficient opportunity to modify your subscriptions or memberships,
            your continued use of the Service will constitute your agreement to
            pay the updated prices. If your payment method fails, for whatever
            reason, you will be responsible for providing a replacement payment
            method to cover current and future payment obligations. If you fail
            to pay any fees or charges when due, you will be responsible for any
            reasonable collection costs that we may incur in efforts to collect
            any unpaid balances from you.&nbsp;
          </TermP>
          <TermP>
            <Strong>Membership &amp; Subscriptions.</Strong> If your purchase
            includes a membership, then you will be billed for the membership on
            a subscription basis. For subscriptions, you will be charged for the
            first month beginning on the day after your free trial ends. For
            subsequent months, you will be billed on a recurring monthly basis
            ("Billing Cycle"). At the end of each Billing Cycle, your
            subscription will automatically renew under the exact same
            conditions until cancellation.&nbsp;&nbsp;
          </TermP>
          <TermP>
            <Strong>Deposits.</Strong> All deposits are refundable up to thirty
            (30) days before the start of the respective program, at which time
            you will be charged for any remaining balance on your respective
            purchase.&nbsp;&nbsp;
          </TermP>
          <TermP>
            <Strong>Discounts &amp; Early Cancellation. </Strong>If you receive
            a discount for a multi-month commitment and cancel prior to the end
            of the discounted term, you will be subject to an early cancellation
            fee equal to the total discount that you received.
          </TermP>
          <TermP>
            <Strong>Refunds. </Strong>All sales are final. Certain refund
            requests may be considered by Codehall on a case-by-case basis and
            granted at the sole discretion of Codehall. In order to request a
            refund, send an email with the subject “Refund Request” to{" "}
            <a href="mailto:support@codehall.ca">
              <u>support@codehall.ca</u>
            </a>{" "}
            stating the amount of the requested refund and reason.
          </TermP>
          <TermP>
            <Strong>Rescheduling &amp; Canceling.</Strong> If you would like to
            reschedule or cancel a registered session, you can do so using
            your&nbsp;
            <a href="http://account.codehall.ca/">Codehall Parent Portal</a>
            &nbsp;up to the day prior to your registered session. If you do not
            reschedule or cancel the day before your registered session and you
            miss your registered session, then the session will be deducted from
            your membership.
          </TermP>
          <TermP>
            <Strong>Membership Cancellation. </Strong>If you wish to cancel your
            membership of the Service, you can contact the Codehall customer
            support team by email (
            <a href="mailto:support@codehall.ca">support@codehall.ca</a>).
            Please note that termination is effective only once confirmed in
            writing by our team and your cancellation will start from your next
            bill date onwards. At the time of cancellation, you will be
            responsible for any outstanding charges associated with your
            account. If you cancel your membership, you will no longer be
            eligible for any promotional pricing in place before cancelling if
            you decide to reactivate later.
          </TermP>
          <TermP>
            <Strong>Termination. </Strong>We may suspend or terminate your
            account and/or access to the Service, without prior notice or
            liability, at our sole discretion, for any reason whatsoever and
            without limitation, including but not limited to a breach of the
            Terms. All provisions of the Terms which by their nature should
            survive termination shall survive termination, including, without
            limitation ownership provisions, warranty disclaimers, indemnity,
            and limitations of liability.
          </TermP>

          <TermHeader>Our Communications</TermHeader>
          <TermP>
            For contractual purposes, you consent to receive communications from
            Company in electronic form to the email address that you have
            submitted, and agree that all Terms, agreements, notices,
            disclosures, and other communications that Company provides to you
            electronically satisfy any legal requirement that such
            communications would satisfy if they were in writing. The foregoing
            does not affect your nonwaivable rights. We may also use your email
            address to send you other messages, including information about
            Codehall and special offers. You may opt out of such email by
            changing your account settings or sending an email to{" "}
            <a href="mailto:support@codehall.ca">
              <u>support@codehall.ca</u>
            </a>
            .
          </TermP>
          <TermHeader>Intellectual Property</TermHeader>
          <TermP>
            While we retain ownership of all our intellectual property described
            herein, Codehall is happy to grant licenses to empower kids to use
            the amazing games that they build for certain purposes -- just let
            us know how you want to use your game by emailing{" "}
            <a href="mailto:legal@codehall.ca">
              <u>legal@codehall.ca</u>
            </a>
            .{" "}
          </TermP>
          <TermP>
            You acknowledge and agree that Codehall retains ownership of all
            intellectual property rights of any kind related to the Service,
            including applicable copyrights, trademarks, and other proprietary
            rights. We reserve all rights that are not expressly granted to you
            under the Terms. The Service and its original content, features, and
            functionality are and will remain the exclusive property of
            Codehall and its licensors. The Service is protected by copyright,
            trademark, and other laws of both the United States and foreign
            countries. Our trademarks and trade dress may not be used in
            connection with any product or service without the prior written
            consent of Codehall. The trademarks and trade dress of Codehall
            are proprietary to us and may not be used by you for any reasons
            other than as expressly permitted by these Terms. All website
            content, design, text, graphics, and interfaces; the collection,
            selection, and arrangement thereof; and all software are property
            of, or duly licensed to, Company. Any other use of materials on our
            website, including modification, distribution, or reproduction for
            purposes other than those noted above, without the prior written
            permission of Codehall, is strictly prohibited. You acknowledge
            that Codehall and/or third-party content providers remain the
            owners of all website materials and that you do not acquire any of
            those ownership rights by downloading, copying, or using any such
            material in accordance with these Terms. Codehall may discontinue
            or remove the website, or any portion thereof, or discontinue your
            right to use the website, or any portion thereof, at any time. By
            posting any content using the Service, you expressly grant,
            represent, and warrant that you have a right to grant to Company a
            royalty-free, sublicensable, transferable, perpetual, irrevocable,
            non-exclusive, worldwide license to use, reproduce, modify, publish,
            list information regarding, edit, translate, distribute, publicly
            perform, publicly display, and make derivative works of all such
            content, in whole or in part, in any form, media, or technology,
            whether now known or hereafter developed, for use in connection with
            the Service or promotion thereof.{" "}
          </TermP>
          <TermHeader>Third-Party Content</TermHeader>
          <TermP>
            As part of the Service, Company may provide you with convenient
            links to third-party websites as well as content or items belonging
            to or originating from third parties. These links are provided as a
            courtesy to Service users, but Codehall is not responsible for the
            actions of third parties as their actions are outside of our
            control. Accordingly, you should review the applicable terms and
            policies, including privacy and data collection practices, of any
            site to which you navigate or relating to any applications that you
            use or install from any third-party content.
          </TermP>
          <TermHeader>Indemnification</TermHeader>
          <TermP>
            You agree to release, defend, indemnify, and hold harmless Codehall
            and its licensees, licensors, employees, contractors, agents,
            officers and directors, from and against any and all claims,
            damages, obligations, losses, liabilities, costs, debt, and expenses
            (including but not limited to attorneys’ fees), resulting from or
            arising out of your use and access of the Service, by you or any
            person using your account and/or breaching these Terms. If you have
            a dispute with one or more users of the Service or a third-party
            merchant of a product or service, you agree to release Codehall
            (and its officers, directors, agents, subsidiaries, joint ventures,
            and employees) from any and all claims, demands, and damages (actual
            and consequential) of every kind and nature, known and unknown,
            arising out of or in any way connected with such disputes.
          </TermP>
          <TermHeader>Warranty Disclaimer</TermHeader>
          <TermP>
            THE SERVICE IS PROVIDED “AS IS” WITHOUT WARRANTY OF ANY KIND.
            WITHOUT LIMITING THE FOREGOING, COMPANY EXPRESSLY DISCLAIMS ALL
            WARRANTIES, WHETHER EXPRESS, IMPLIED, OR STATUTORY, REGARDING THE
            SERVICE INCLUDING WITHOUT LIMITATION ANY WARRANTY OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, SECURITY,
            ACCURACY, AND NON-INFRINGEMENT. WITHOUT LIMITING THE FOREGOING,
            COMPANY MAKES NO WARRANTY OR REPRESENTATION THAT ACCESS TO OR
            OPERATION OF THE SERVICE WILL BE UNINTERRUPTED OR ERROR-FREE. YOU
            ASSUME FULL RESPONSIBILITY AND RISK OF LOSS RESULTING FROM YOUR
            DOWNLOADING AND/OR USE OF FILES, INFORMATION, CONTENT, OR OTHER
            MATERIAL OBTAINED FROM THE SERVICE.&nbsp;
          </TermP>
          <TermHeader>Limitation of Liability</TermHeader>
          <TermP>
            TO THE EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL
            COMPANY, INCLUDING WITHOUT LIMITATION ITS AFFILIATES, DIRECTORS,
            EMPLOYEES, LICENSORS, PARTNERS, OR AGENTS, BE LIABLE TO YOU FOR ANY
            LOSS OF PROFITS, DATA, USE, GOODWILL, OR OTHER TANGIBLE LOSSES, OR
            FOR ANY INCIDENTAL, INDIRECT, SPECIAL, CONSEQUENTIAL, OR EXEMPLARY
            DAMAGES RESULTING FROM YOUR ACCESS TO OR USE OF OR INABILITY TO
            ACCESS OR USE THE SERVICE; THE USE, DISCLOSURE, OR DISPLAY OF YOUR
            USER CONTENT OR ANY CONTENT; YOUR USE OR INABILITY TO USE THE
            SERVICE; THE SERVICE GENERALLY OR THE SOFTWARE OR SYSTEMS THAT MAKE
            THE SERVICE AVAILABLE; ANY CONDUCT OR CONTENT OF ANY THIRD PARTY ON
            THE SERVICE; OR ANY OTHER INTERACTIONS WITH COMPANY OR ANY OTHER
            USER OF THE SERVICE, WHETHER BASED ON WARRANTY, CONTRACT, TORT
            (INCLUDING NEGLIGENCE) OR ANY OTHER LEGAL THEORY, AND WHETHER OR NOT
            COMPANY HAS BEEN INFORMED OF THE POSSIBILITY OF SUCH DAMAGE, AND
            EVEN IF A REMEDY SET FORTH HEREIN IS FOUND TO HAVE FAILED OF ITS
            ESSENTIAL PURPOSE. ANY LEGAL ACTION BY EITHER PARTY ARISING UNDER
            THIS AGREEMENT MUST BE FILED WITHIN TWELVE (12) MONTHS FROM THE DATE
            THAT SUCH CLAIM ARISES AND BOTH PARTIES WAIVE ANY RIGHT TO FILE ANY
            ACTION ARISING UNDER THIS AGREEMENT UNDER ANY LONGER STATUTE OF
            LIMITATIONS PERIOD. YOU FURTHER ACKNOWLEDGE THAT CODEHALL AND THE
            RELEASED PARTIES ARE NOT RESPONSIBLE FOR THE ERRORS, OMISSIONS,
            ACTS, OR FAILURES TO ACT OF ANY PARTY CONDUCTING A SPECIFIC EVENT,
            ACTIVITY, OR EXPERIENCE ON BEHALF OF CODEHALL.&nbsp;&nbsp;
          </TermP>
          <TermHeader>Governing Law &amp; Dispute Resolution</TermHeader>
          <TermP>
            In the unfortunate event of any controversy or claim arising out of
            or relating to these Terms and your use of the Service, you agree
            that we will attempt to resolve any dispute through amicable,
            confidential negotiation amongst the parties. If the matter is not
            resolved by negotiation, then the dispute shall be settled by
            arbitration in accordance with the Commercial Arbitration Rules of
            the American Arbitration Association, and judgment upon the award
            rendered by the arbitrator(s) may be entered in any court having
            jurisdiction thereof. The prevailing Party in any such dispute is
            entitled to recover its reasonable fees and costs, including without
            limitation reasonable attorneys’ fees. Any judgment under this
            section is fully enforceable in your country and state of residence.
            THE PARTIES EXPRESSLY WAIVE THE RIGHT TO A JURY TRIAL IN ANY ACTION
            RELATING TO THIS AGREEMENT.
          </TermP>
          <TermHeader>Severability</TermHeader>
          <TermP>
            We reserve the right, at our sole discretion, to modify these Terms
            at any time. It is your responsibility to check the website from
            time to time to view any such changes. If you continue to use the
            Service, you signify your agreement to our amendments to the Terms.
            If we make a material revision to our Terms, we will send an email
            to the email address that you provided during registration. What
            constitutes a material change will be determined at our sole
            discretion. It is your responsibility to keep your contact and
            account information current. Any changes to these Terms (other than
            as set forth in this paragraph) or waiver of Company’s rights
            hereunder shall not be valid or effective except in a written
            agreement bearing the physical signature of an officer of Company.
            Our failure to enforce any right or provision of these Terms will
            not be considered a waiver of those rights.&nbsp;
          </TermP>
          <TermHeader>Modification</TermHeader>
          <TermP>
            We reserve the right, at our sole discretion, to modify these Terms
            at any time. It is your responsibility to check the website from
            time to time to view any such changes. If you continue to use the
            Service, you signify your agreement to our amendments to the Terms.
            If we make a material revision to our Terms, we will send an email
            to the email address that you provided during registration. What
            constitutes a material change will be determined at our sole
            discretion. It is your responsibility to keep your contact and
            account information current. Any changes to these Terms (other than
            as set forth in this paragraph) or waiver of Company’s rights
            hereunder shall not be valid or effective except in a written
            agreement bearing the physical signature of an officer of Company.
            Our failure to enforce any right or provision of these Terms will
            not be considered a waiver of those rights.&nbsp;
          </TermP>
          <TermHeader>Notice</TermHeader>
          <TermP>
            Any legal notice must be provided via certified mail to:
          </TermP>
          <TermP>
            <Strong>
              Teach a Billion Kids to Code, LLC Attn: Legal 1440 N Dayton St,
              Suite 100 Chicago, IL 60642
            </Strong>
          </TermP>
          <TermHeader>Contact</TermHeader>
          <TermP>The Codehall team is here for you. Feel free to email us (<a href="mailto:support@codehall.ca">support@codehall.ca</a>) with your questions and suggestions.</TermP>
          <TermP><Strong>Last updated: September 2, 2020</Strong></TermP>
        </Terms>
      </TermsBox>
    )
  }
}
